module.exports = __webpack_public_path__ + "static/media/IMG-2.770c4941.jpg";